import { TextProps, Text } from "@chakra-ui/react";

const CallTicketText = (props: TextProps) => (
  <Text fontSize={{ base: "xs", "2xl": "md" }} {...props} />
);

export default CallTicketText;
